"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomaticAslSweepBehavior = exports.AutomaticAslSweepOfferType = void 0;
/**
 * Offer type for Automatic ASL Sweep (ASL = Aven Simple Loan).
 * Shared between TypeScript and Python via @TranslateToPython.
 */
/** @TranslateToPython */
var AutomaticAslSweepOfferType;
(function (AutomaticAslSweepOfferType) {
    AutomaticAslSweepOfferType["fixedApr"] = "fixedApr";
})(AutomaticAslSweepOfferType || (exports.AutomaticAslSweepOfferType = AutomaticAslSweepOfferType = {}));
/**
 * Behavior state for automatic ASL sweep feature.
 * - enabled: Sweep should run automatically for each eligible statement period.
 * - disabled: Sweep should not run. User has opted out of automatic sweeps.
 */
var AutomaticAslSweepBehavior;
(function (AutomaticAslSweepBehavior) {
    AutomaticAslSweepBehavior["enabled"] = "enabled";
    AutomaticAslSweepBehavior["disabled"] = "disabled";
})(AutomaticAslSweepBehavior || (exports.AutomaticAslSweepBehavior = AutomaticAslSweepBehavior = {}));
